<!--  -->
<template>
  <div class='selectCategory'>
    <el-dialog title="选择供方分类"
            width="40%"
            :close-on-click-modal="$root.dialogAutoClose"
            :close-on-press-escape="$root.dialogAutoClose"
            :visible.sync="treeDialog">
        <div style="max-height: 500px;overflow-y: auto;">
            <el-tree :data="treeData"
                    :check-strictly="true"
                    :props="$root.treeProps"
                    highlight-current
                    :expand-on-click-node="false"
                    :show-checkbox="true"
                    :default-checked-keys="defaultCheckedKeys"
                    node-key="id"
                    ref="categoryTree"
                    @check-change="handleCheckChange"
                    @node-click="nodeClick"></el-tree>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="treeDialog = false">取 消</el-button>
            <el-button type="primary" @click="treeConfirm">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.component('select-category', {
//import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
        showMessageDiv :false,
        //供方分类
        categoryTreeList: [],
        categoryTreeListCopy: [],
        treeDialog: false,
        treeData: [],
        defaultCheckedKeys: [],

        checkedId: '',
        selectedSupplierCategorys: [],
    }
  },
    props:{
        categoryStatus:{
            default:""
        },
        pageTye:{
          default:'1'
        }
    },
//方法集合
  methods: {
    handleCheckChange(data, checked, node){
        if(checked == true){
          this.checkedId = data.id;
          this.$refs.categoryTree.setCheckedNodes([data]);
        }
    },
    nodeClick(data,checked,node){
        if(data.categoryLevel == 3){
          this.checkedId = data.id
          this.$refs.categoryTree.setCheckedNodes([data]);
        }
    },
    getLinkTreeList(id){
      let that = this;
        that.$root.postHttp('/v1/sSuppliersCategory/public/findSuppliersLinkCategoryTreeList',{
            "categoryStatus": this.categoryStatus,
            "pageFlag": 0,
            "pageNumber": 0,
            "pageSize": 0,
            "supplierId":id
        },function (res) {
            that.categoryTreeList = res.data.data.tree;
            that.treeData = that.categoryTreeList;
            console.log(222,that.treeData)
        });
    },
    //获取供方分类完整树形数据
    getTreeList(){
        let that = this;
        that.$root.postHttp('/v1/sSuppliersCategory/public/findSuppliersCategoryTreeList',{
            "categoryStatus": this.categoryStatus,
            "pageFlag": 0,
            "pageNumber": 0,
            "pageSize": 0
        },function (res) {
            that.categoryTreeList = res.data.data.tree;
        });
    },
    show(type=0,id=''){
      this.treeDialog = true;
      console.log(1111,id)
      if(type==2){
        if(id){
          this.getLinkTreeList(id)
        }
      }else{
        this.treeData = this.categoryTreeList;
      }
    },
    treeConfirm(){
      let that = this;
      let selectedData = that.$refs['categoryTree'].getCheckedNodes(true);
      that.selectedSupplierCategorys = selectedData;
      if(this.selectedSupplierCategorys.length==0){
          this.$alert('请选择供方分类！',{
              type:'warning'
          });
          return;
      }

      that.$emit("callback", that.selectedSupplierCategorys[0]);
      that.treeDialog = false;
      that.$refs.categoryTree.setCheckedKeys([]);
  },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if(this.pageTye!='2'){
      this.getTreeList();
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
})
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.selectCategory /deep/{
  .el-tree-node{
      .is-leaf + .el-checkbox .el-checkbox__inner{
          display: inline-block;
      }
      .el-checkbox .el-checkbox__inner{
          display: none;
      }

      .el-checkbox__input.is-disabled {
        .el-checkbox__inner {
          cursor: default;
        }
      }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/common/SelectCategory.vue